import { createFileRoute } from '@tanstack/react-router';
import { TasksSettingsPage } from '../../screens/settings/TasksSettings';

export const Route = createFileRoute('/settings/tasks')({
  component: TasksSettingsPage,
});
